import { createSlice } from '@reduxjs/toolkit'

const initialState = {accessToken:'', refreshToken:'', user:''}

const superAdminSlice = createSlice({
  name: 'superAdmin',
  initialState,
  reducers: {
    setSuperAdmin(state, action) {
       return action.payload
    }
  },
  updateTokens: (state, action) => {
    state.accessToken = action.payload.accessToken;
    state.refreshToken = action.payload.refreshToken;
  },
})

export const { setSuperAdmin, updateTokens } = superAdminSlice.actions
export default superAdminSlice.reducer